import axios from "axios";
import { useSelector } from "react-redux";
import { ReduxState } from "@/redux/type";
export default function useAxios() {
    const session = useSelector((state: ReduxState) => state.session)
    const program = useSelector((state: ReduxState) => state.program)

    function buildHeaders(headers?: any) {
        const nextHeaders: any = {
            ...headers,
            Authorization: `Bearer ${session.sessionToken}`
        };
        if (program?.programId) {
            nextHeaders.programId = program.programId;
        }
        return nextHeaders;
    }
    
    async function get(url: string, config?: any) {
        let cfg: any = config ? config : {}
        cfg.headers = buildHeaders(cfg.headers);
        const response = await axios.get(url, cfg);
        return response
    }

    async function post(url: string, data: any, config?: any) {
        let cfg: any = config ? config : {}
        cfg.headers = buildHeaders(cfg.headers);
        let response = await axios.post(url, data, cfg);
        return response
    }

    async function patch(url: string, data: any, config?: any) {
        let cfg: any = config ? config : {}
        cfg.headers = buildHeaders(cfg.headers);
        let response = await axios.patch(url, data, cfg);
        return response
    }

    async function put(url: string, data: any, config?: any) {
        let cfg: any = config ? config : {}
        cfg.headers = buildHeaders(cfg.headers);
        let response = await axios.put(url, data, cfg);
        return response
    }

    async function del(url: string, config?: any) {
        let cfg: any = config ? config : {}
        cfg.headers = buildHeaders(cfg.headers);
        const response = await axios.delete(url, cfg);
        return response
    }

    return { get, post, patch, put, del };
}
